/* eslint-disable */
import { useState, useEffect } from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Hero from '../../components/Hero/Hero';
import Button from '../../components/Button/Button';
import Bigcard from '../../components/BigCard/Bigcard';
import { Helmet } from 'react-helmet';
import { Tabs } from 'antd';

import { bigCardData } from '../../data';

import students from '../../assets/images/for-students.png';
import parents from '../../assets/images/parents.png';
import schoolsImage from '../../assets/images/for-schools.png';
import tutor from '../../assets/images/tutor.png';
import SchoolCard from '../../components/SchoolCard/SchoolCard';
import { responsive } from '../../data';
import Carousel from 'react-multi-carousel';
import { useNavigate } from 'react-router';
import { withTranslation } from 'react-i18next';

import { Element } from 'react-scroll';

import Fade from 'react-reveal/Fade';
import { baseURL } from '../../utils/axios';
import ReactPixel from 'react-facebook-pixel';

const Home = ({ t, i18n }) => {
  const navigate = useNavigate();
  const [schools, setSchools] = useState([]);

  useEffect(() => {
    ReactPixel.pageView(); // Track a page view event
  }, []);

  useEffect(() => {
    let token = localStorage.getItem('token');

    const getAllSchools = async () => {
      const res = await fetch(`${baseURL}/schools`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      const data = await res.json();

      if (res.status === 200) {
        setSchools(data.data.schools);
      }

      if (res.status === 401) {
        notification['error']({
          message: 'Session expired, please log in again',
        });
        localStorage.clear();
        navigate('/login');
      }
    };
    getAllSchools();
  }, []);

  return (
    <div>
      <Helmet>
        <title>
          Personalised Education provided by top rated schools and teachers | PL
          by Edves
        </title>
      </Helmet>
      <Header />
      <Hero />

      <div
        className='dashboard-body'
        style={{ marginTop: '60px', overflow: 'hidden' }}
      >
        <div
          className='recommended-section__title'
          style={{ marginBottom: '40px' }}
        >
          <h1>{t('Learn from top schools and tutors')}</h1>
          <p>
            Over {schools?.length} schools have uploaded learning <br />
            resources and assessments to help you in your academic journey
          </p>
        </div>
        <div className='schools-flex'>
          <Tabs defaultActiveKey='1'>
            <Tabs.TabPane tab='Nigeria' key='1'>
              {schools.length === 0 ? (
                <div>No schools found</div>
              ) : (
                <Carousel
                  shouldResetAutoplay={false}
                  responsive={responsive}
                  showDots={true}
                  itemClass={`carouselItem`}
                >
                  {/* <div className="dashboard-body__subject-row"> */}
                  {schools.length === 0 ? (
                    <div></div>
                  ) : (
                    schools?.slice(0, 6)?.map((el, index) => (
                      <SchoolCard
                        key={el.id}
                        schoolLogo={el.logo}
                        schoolHeader={el.logo}
                        schoolName={el.name}
                        subjectNo={el.subject_classes_count}
                        description={el.bio}
                        activities={el.activity_count}
                        location={`${el.country ? el.country : 'Nigeria'}`}
                        lessonCount={el.lessons_count}
                        selectSchool={() => {
                          navigate(
                            `/schools/${el.link_id ? el.link_id : el.id}`
                          );
                        }}
                        page='dashboard'
                        type='school'
                        index={index}
                      />
                    ))
                  )}
                  {/* </div> */}
                </Carousel>
              )}
            </Tabs.TabPane>
          </Tabs>

          <div
            className='schools-flex__view-all'
            onClick={() => navigate('/all-schools')}
          >
            <p>View All</p>
            <div className='schools-flex__view-all__svg'>
              <svg
                width='6'
                height='8'
                viewBox='0 0 6 8'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M1.66656 0L0.726562 0.94L3.7799 4L0.726562 7.06L1.66656 8L5.66656 4L1.66656 0Z'
                  fill='#FEA82F'
                />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div className='how-section'>
        <div className='how-section__top'>
          <div className='how-section__top__left'>
            <Fade up>
              <h2>
                How we help put <br /> students on the right <br /> path to
                success
              </h2>
            </Fade>
          </div>

          <div className='how-section__top__right'>
            <Fade up>
              <p>
                Get access to standard educational content
                <br />
                and personalize your learning experience with <br /> one- on-
                one classes
              </p>
            </Fade>
          </div>
        </div>
        <div className='how-section__cards-wrapper'>
          {bigCardData.map((el) => (
            <div key={el.id}>
              <Bigcard
                title={el.title}
                icon={el.icon}
                bodyText={el.bodyText}
                color={el.color}
                border={el.border}
              />
            </div>
          ))}
        </div>
      </div>
      <Element name='students'>
        <div className='for-students'>
          <Fade left>
            <div className='for-students__img-wrapper'>
              <img src={students} alt='for-students' />
            </div>
          </Fade>

          <div className='for-students__right'>
            <Fade right>
              <div className='for-students__right__tag for-students-bg'>
                <p>FOR STUDENTS</p>
              </div>

              <h3>
                Search and learn any subject <br /> from any school directly on
                your <br />
                PL by Edves dashboard
              </h3>
              <p>
                Students can be enrolled into any subject delivered and assessed{' '}
                <br /> by top school brands across the globe to further boost
                their <br /> academic performance and grades{' '}
              </p>
              <div className='for-students__right__btn'>
                <Button
                  text='Join For Free'
                  className='primary-btn'
                  onClick={() => navigate('/student-signup')}
                />
              </div>
            </Fade>
          </div>
        </div>
      </Element>
      <Element name='parents' className='element'>
        <div className='for-students' style={{ background: '#F5F5F5' }}>
          <Fade left>
            <div className='for-students__right'>
              <div className='for-students__right__tag for-parents-bg'>
                <p>FOR PARENTS</p>
              </div>

              <h3>
                Your kids can learn any subject <br /> from A- list schools
                across <br /> the globe
              </h3>
              <p>
                Your child no longer needs to travel long distances just to
                access <br />
                quality education. You can now sign them up to learn any subject{' '}
                <br /> of interest taught by the best tutors from Ivy League
                schools on <br /> PL by Edves
              </p>
            </div>
          </Fade>

          <div className='for-students__img-wrapper'>
            <Fade right>
              <img src={parents} alt='for-parents' />
            </Fade>
          </div>
        </div>
      </Element>

      <Element name='schools' className='element'>
        <div className='for-students'>
          <Fade left>
            <div className='for-students__img-wrapper'>
              <img src={schoolsImage} alt='for-students' />
            </div>
          </Fade>
          <div className='for-students__right'>
            <Fade right>
              <div className='for-students__right__tag for-schools-bg'>
                <p>FOR SCHOOLS</p>
              </div>

              <h3>
                An opportunity to teach beyond <br /> the four walls of the
                school
              </h3>
              <p>
                Set your school on the map of the world, reposition your brand
                as <br /> an international study option. <br /> K-12 learners
                can now take classes at your school from anywhere <br /> in the
                world on PL by Edves
              </p>
              <div className='for-students__right__btn'>
                <Button
                  text='Join For Free'
                  className='primary-btn'
                  onClick={() => navigate('/schools')}
                />
              </div>
            </Fade>
          </div>
        </div>
      </Element>

      <Element name='tutors' className='element'>
        <div className='for-students' style={{ background: '#F5F5F5' }}>
          <Fade right>
            <div className='for-students__right'>
              <div
                className='for-students__right__tag for-tutors-bg'
                style={{ width: '200px', backgroundSize: 'cover' }}
              >
                <p>FOR INDEPENDENT TUTORS</p>
              </div>

              <h3>
                Explore borderless teaching <br /> across the globe
              </h3>
              <p>
                Increase your revenue as a tutor with PL by Edves, make an
                impact <br /> in the academic success of learners.
                <br /> K-12 learners can now take bite- size topics from
                anywhere in the <br /> world on PL by Edves
              </p>

              <div className='for-students__right__btn'>
                <Button
                  text='Join For Free'
                  className='primary-btn'
                  onClick={() => navigate('/school-register')}
                />
              </div>
            </div>
          </Fade>

          <div className='for-students__img-wrapper'>
            <Fade left>
              <img src={tutor} alt='for-parents' />
            </Fade>
          </div>
        </div>
      </Element>

      {/* <div className="explore">
        <div className="explore__title">
          <h3>Explore PL by Edves</h3>
        </div>
        <div className="explore__card-wrapper">
          {smallCardData.map((el) => (
            <SmallCard title={el.title} img={el.img} key={el.id} />
          ))}
        </div>
      </div> */}
      <div className='texture-bg'>
        <div className='cta'>
          <div className='cta__left'>
            <h1>
              Your academic subject weakness can become an area of strength
            </h1>
            <p>Sign up on PL by Edves and become academic stars</p>
          </div>
          <div className='cta__right'>
            <Button
              className='secondary-button'
              text='Join For Free'
              onClick={() => navigate('/school-register')}
            />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default withTranslation()(Home);
